<template>
  <div class="material-list-page">
    <div class="container">
      <div class="row custom-row-override">
        <h2 class="section-title">Compression Molding Materials</h2>

        <div class="materials-grid">
          <label class="material-item" v-for="(item, index) in materialList" :key="index">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24" class="svg">
              <path d="M0 0h24v24H0z" fill="none" />
              <g fill="none" fill-rule="evenodd">
                <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                <path fill="currentColor" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2h14v14H5zm11.95 4.795a1 1 0 1 0-1.414-1.414l-4.95 4.95l-2.121-2.121a1 1 0 0 0-1.415 1.414l2.758 2.758a1.1 1.1 0 0 0 1.556 0z" />
              </g>
            </svg>
            <span class="material-name">{{ item }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Compression_Materials',
  data() {
    return {
      materialList: [
        'Silicone',
        'Natural Rubber (NR)',
        'NBR (Buna-N)',
        'HNBR',
        'EPDM Rubber',
        'SBR',
        'Neoprene (CR)',
        'FKM (Viton)',
        'Polyurethane (PU)'
      ]
    }
  }
}
</script>

<style scoped>
/* =======================================
   下面是电脑端基础样式（绝对不改动）
======================================= */
.material-list-page {
  padding: 40px 20px;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.container {
  max-width: 1080px;
  margin: 0 auto;
}

.section-title {
  font-size: 32px;
  color: #333333;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 40px;
}

.materials-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); 
  gap: 24px 20px;
  flex-shrink: 0; 
}

.material-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 600;
  color: #333;
}

.svg {
  color: #c2c2c2;
}

/* =======================================
   移动端及平板端适配优化（终极居中对齐版）
======================================= */
@media (max-width: 992px) {
  /* 强制清除任何可能引起错位的全局样式影响 */
  .custom-row-override {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
  }

  .section-title {
    font-size: 32px;
    margin-bottom: 30px; 
    text-align: center;
  }

  .materials-grid {
    display: grid;
    /* 核心 1：宽度设为 100%，占满整行 */
    width: 100% !important;
    /* 核心 2：用 max-content 强制列宽正好等于文字长度 */
    grid-template-columns: repeat(3, max-content);
    /* 核心 3：把这三列文字在 100% 的空间里强行居中！ */
    justify-content: center;
    gap: 24px 40px; 
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 28px;
  }
  .materials-grid {
    /* iPad 变为 2 列，依然紧凑居中 */
    grid-template-columns: repeat(2, max-content);
    gap: 20px 48px;
  }
  .material-item {
    font-size: 16px; 
  }
}

@media (max-width: 480px) {
  .materials-grid {
    /* 手机单列居中 */
    grid-template-columns: max-content;
    gap: 16px;
  }
}
</style>